import {
  PrescriptionForm,
  PrescriptionFormAPI,
} from './prescriptionForm/prescriptionForm';

export class Prescription {
  id: number;
  type: 'initiale' | 'prolongation';
  dateDebut: Date;
  dateFin: Date;
  read_only: boolean;
  dateRetour?: Date;
  prescriptionForm?: PrescriptionForm;
  format?: 'DEP' | 'DAP' | 'Ordonnance';

  accident?: boolean;
  dateAccident?: Date;
  pensionDeGuerre?: boolean;
  couvertureSante?: boolean;
  affectionLongueDureeReconnueSurListe?: boolean;
  affectionLongueDureeReconnueHorsListe?: boolean;
  aLActe?: boolean;
  association?: boolean;
  nomAssociation?: string;
  adresseAssociation?: string;
  complementAdresseAssociation?: string;
  numeroForfait?: string;
  specialitePrescripteur?: string;

  oxygenotherapieParConcentrateur?: boolean;
  posteFixeOxygenotherapieParConcentrateur?: boolean;
  deambulationOxygenotherapieParConcentrateur?: boolean;
  dureeOxygenotherapieParConcentrateur?: string;
  debitOxygenotherapieParConcentrateur?: string;

  oxygenotherapieGazeuseParBouteille?: boolean;
  posteFixeOxygenotherapieGazeuseParBouteille?: boolean;
  deambulationOxygenotherapieGazeuseParBouteille?: boolean;
  dureeOxygenotherapieGazeuseParBouteille?: string;
  debitOxygenotherapieGazeuseParBouteille?: string;

  oxygenotherapieLiquide?: boolean;
  posteFixeOxygenotherapieLiquide?: boolean;
  deambulationOxygenotherapieLiquide?: boolean;
  dureeOxygenotherapieLiquide?: string;
  debitOxygenotherapieLiquide?: string;

  ventilationMecaniqueALEmboutBuccal?: boolean;
  dureeVentilationMecaniqueALEmboutBuccal?: string;
  debitVentilationMecaniqueALEmboutBuccal?: string;

  ventilationMecaniqueParMasqueNasal?: boolean;
  dureeVentilationMecaniqueParMasqueNasal?: string;
  debitVentilationMecaniqueParMasqueNasal?: string;

  ventilationMecaniqueParTracheotomie?: boolean;
  dureeVentilationMecaniqueParTracheotomie?: string;
  debitVentilationMecaniqueParTracheotomie?: string;

  ventilationMecaniqueParProtheseExtraThoracique?: boolean;
  dureeVentilationMecaniqueParProtheseExtraThoracique?: string;
  debitVentilationMecaniqueParProtheseExtraThoracique?: string;

  ventilationMecaniqueParPressionPositiveContinue?: boolean;
  dureeVentilationMecaniqueParPressionPositiveContinue?: string;
  debitVentilationMecaniqueParPressionPositiveContinue?: string;

  aspirationSansVentilationSurTracheotomie?: boolean;

  autre?: boolean;

  marqueOxygenotherapieParConcentrateur?: string;
  typeOxygenotherapieParConcentrateur?: string;

  marqueOxygenotherapieLiquide?: string;
  typeOxygenotherapieLiquide?: string;

  marqueRespirateur?: string;
  typeRespirateur?: string;

  marqueAutre?: string;
  typeAutre?: string;

  constructor(
    id: number,
    type: 'initiale' | 'prolongation',
    dateDebut: Date,
    dateFin: Date,
    read_only: boolean,
    dateRetour?: Date,
    prescriptionForm?: PrescriptionForm,
    format?: 'DEP' | 'DAP' | 'Ordonnance',
    accident?: boolean,
    dateAccident?: Date,
    pensionDeGuerre?: boolean,
    couvertureSante?: boolean,
    affectionLongueDureeReconnueSurListe?: boolean,
    affectionLongueDureeReconnueHorsListe?: boolean,
    aLActe?: boolean,
    association?: boolean,
    nomAssociation?: string,
    adresseAssociation?: string,
    complementAdresseAssociation?: string,
    numeroForfait?: string,
    specialitePrescripteur?: string,
    oxygenotherapieParConcentrateur?: boolean,
    posteFixeOxygenotherapieParConcentrateur?: boolean,
    deambulationOxygenotherapieParConcentrateur?: boolean,
    dureeOxygenotherapieParConcentrateur?: string,
    debitOxygenotherapieParConcentrateur?: string,
    oxygenotherapieGazeuseParBouteille?: boolean,
    posteFixeOxygenotherapieGazeuseParBouteille?: boolean,
    deambulationOxygenotherapieGazeuseParBouteille?: boolean,
    dureeOxygenotherapieGazeuseParBouteille?: string,
    debitOxygenotherapieGazeuseParBouteille?: string,
    oxygenotherapieLiquide?: boolean,
    posteFixeOxygenotherapieLiquide?: boolean,
    deambulationOxygenotherapieLiquide?: boolean,
    dureeOxygenotherapieLiquide?: string,
    debitOxygenotherapieLiquide?: string,
    ventilationMecaniqueALEmboutBuccal?: boolean,
    dureeVentilationMecaniqueALEmboutBuccal?: string,
    debitVentilationMecaniqueALEmboutBuccal?: string,
    ventilationMecaniqueParMasqueNasal?: boolean,
    dureeVentilationMecaniqueParMasqueNasal?: string,
    debitVentilationMecaniqueParMasqueNasal?: string,
    ventilationMecaniqueParTracheotomie?: boolean,
    dureeVentilationMecaniqueParTracheotomie?: string,
    debitVentilationMecaniqueParTracheotomie?: string,
    ventilationMecaniqueParProtheseExtraThoracique?: boolean,
    dureeVentilationMecaniqueParProtheseExtraThoracique?: string,
    debitVentilationMecaniqueParProtheseExtraThoracique?: string,
    ventilationMecaniqueParPressionPositiveContinue?: boolean,
    dureeVentilationMecaniqueParPressionPositiveContinue?: string,
    debitVentilationMecaniqueParPressionPositiveContinue?: string,
    aspirationSansVentilationSurTracheotomie?: boolean,
    autre?: boolean,
    marqueOxygenotherapieParConcentrateur?: string,
    typeOxygenotherapieParConcentrateur?: string,
    marqueRespirateur?: string,
    typeRespirateur?: string,
    marqueOxygenotherapieLiquide?: string,
    typeOxygenotherapieLiquide?: string,
    marqueAutre?: string,
    typeAutre?: string,
  ) {
    this.id = id;
    this.type = type;
    this.dateDebut = dateDebut;
    this.dateFin = dateFin;
    this.read_only = read_only;
    this.dateRetour = dateRetour;
    this.prescriptionForm = prescriptionForm;
    this.format = format;
    this.accident = accident;
    this.dateAccident = dateAccident;
    this.pensionDeGuerre = pensionDeGuerre;
    this.couvertureSante = couvertureSante;
    this.affectionLongueDureeReconnueSurListe =
      affectionLongueDureeReconnueSurListe;
    this.affectionLongueDureeReconnueHorsListe =
      affectionLongueDureeReconnueHorsListe;
    this.aLActe = aLActe;
    this.association = association;
    this.nomAssociation = nomAssociation;
    this.adresseAssociation = adresseAssociation;
    this.complementAdresseAssociation = complementAdresseAssociation;
    this.numeroForfait = numeroForfait;
    this.specialitePrescripteur = specialitePrescripteur;
    this.oxygenotherapieParConcentrateur = oxygenotherapieParConcentrateur;
    this.posteFixeOxygenotherapieParConcentrateur =
      posteFixeOxygenotherapieParConcentrateur;
    this.deambulationOxygenotherapieParConcentrateur =
      deambulationOxygenotherapieParConcentrateur;
    this.dureeOxygenotherapieParConcentrateur =
      dureeOxygenotherapieParConcentrateur;
    this.debitOxygenotherapieParConcentrateur =
      debitOxygenotherapieParConcentrateur;
    this.oxygenotherapieGazeuseParBouteille =
      oxygenotherapieGazeuseParBouteille;
    this.posteFixeOxygenotherapieGazeuseParBouteille =
      posteFixeOxygenotherapieGazeuseParBouteille;
    this.deambulationOxygenotherapieGazeuseParBouteille =
      deambulationOxygenotherapieGazeuseParBouteille;
    this.dureeOxygenotherapieGazeuseParBouteille =
      dureeOxygenotherapieGazeuseParBouteille;
    this.debitOxygenotherapieGazeuseParBouteille =
      debitOxygenotherapieGazeuseParBouteille;
    this.oxygenotherapieLiquide = oxygenotherapieLiquide;
    this.posteFixeOxygenotherapieLiquide = posteFixeOxygenotherapieLiquide;
    this.deambulationOxygenotherapieLiquide =
      deambulationOxygenotherapieLiquide;
    this.dureeOxygenotherapieLiquide = dureeOxygenotherapieLiquide;
    this.debitOxygenotherapieLiquide = debitOxygenotherapieLiquide;
    this.ventilationMecaniqueALEmboutBuccal =
      ventilationMecaniqueALEmboutBuccal;
    this.dureeVentilationMecaniqueALEmboutBuccal =
      dureeVentilationMecaniqueALEmboutBuccal;
    this.debitVentilationMecaniqueALEmboutBuccal =
      debitVentilationMecaniqueALEmboutBuccal;
    this.ventilationMecaniqueParMasqueNasal =
      ventilationMecaniqueParMasqueNasal;
    this.dureeVentilationMecaniqueParMasqueNasal =
      dureeVentilationMecaniqueParMasqueNasal;
    this.debitVentilationMecaniqueParMasqueNasal =
      debitVentilationMecaniqueParMasqueNasal;
    this.ventilationMecaniqueParTracheotomie =
      ventilationMecaniqueParTracheotomie;
    this.dureeVentilationMecaniqueParTracheotomie =
      dureeVentilationMecaniqueParTracheotomie;
    this.debitVentilationMecaniqueParTracheotomie =
      debitVentilationMecaniqueParTracheotomie;
    this.ventilationMecaniqueParProtheseExtraThoracique =
      ventilationMecaniqueParProtheseExtraThoracique;
    this.dureeVentilationMecaniqueParProtheseExtraThoracique =
      dureeVentilationMecaniqueParProtheseExtraThoracique;
    this.debitVentilationMecaniqueParProtheseExtraThoracique =
      debitVentilationMecaniqueParProtheseExtraThoracique;
    this.ventilationMecaniqueParPressionPositiveContinue =
      ventilationMecaniqueParPressionPositiveContinue;
    this.dureeVentilationMecaniqueParPressionPositiveContinue =
      dureeVentilationMecaniqueParPressionPositiveContinue;
    this.debitVentilationMecaniqueParPressionPositiveContinue =
      debitVentilationMecaniqueParPressionPositiveContinue;
    this.aspirationSansVentilationSurTracheotomie =
      aspirationSansVentilationSurTracheotomie;
    this.autre = autre;
    this.marqueOxygenotherapieParConcentrateur =
      marqueOxygenotherapieParConcentrateur;
    this.typeOxygenotherapieParConcentrateur =
      typeOxygenotherapieParConcentrateur;
    this.marqueOxygenotherapieLiquide = marqueOxygenotherapieLiquide;
    this.typeOxygenotherapieLiquide = typeOxygenotherapieLiquide;
    this.marqueRespirateur = marqueRespirateur;
    this.typeRespirateur = typeRespirateur;
    this.marqueAutre = marqueAutre;
    this.typeAutre = typeAutre;
  }

  static factory(prescriptionAPI: PrescriptionAPI): Prescription {
    const dateFalse = new Date('0001-01-01T00:00:00');
    const dateRetour = new Date(prescriptionAPI.PrescriberResponseDate);

    return new Prescription(
      prescriptionAPI.Number,
      prescriptionAPI.DemandNature == 0 ? 'initiale' : 'prolongation',
      new Date(prescriptionAPI.StartApplicationDate),
      new Date(prescriptionAPI.EndApplicationDate),
      prescriptionAPI.read_only ?? false,
      dateRetour.getTime() != dateFalse.getTime() ? dateRetour : undefined,
      prescriptionAPI.prescription_form
        ? PrescriptionForm.factory(prescriptionAPI.prescription_form)
        : undefined,
      prescriptionAPI.DemandKind == 1
        ? 'Ordonnance'
        : prescriptionAPI.DemandKind == 2
          ? 'DEP'
          : 'DAP',
      prescriptionAPI.PersonalAccident == 1,
      prescriptionAPI.PersonalAccidentDate &&
        prescriptionAPI.PersonalAccidentDate != '0001-01-01T00:00:00'
        ? new Date(prescriptionAPI.PersonalAccidentDate)
        : undefined,
      prescriptionAPI.O2WarPensioner == 1,
      prescriptionAPI.HealthCoverage == 1,
      prescriptionAPI.ALDonList == 1,
      prescriptionAPI.ALDoutsideList == 1,
      prescriptionAPI.O2Stamp == 1,
      prescriptionAPI.O2Organization == 1,
      prescriptionAPI.O2OrganizationName,
      prescriptionAPI.O2OrganizationAddress1,
      prescriptionAPI.O2OrganizationAddress2,
      prescriptionAPI.CarePackageNumber,
      prescriptionAPI.O2OtherPrescriberLabel,
      prescriptionAPI.O2Concentrator == 1,
      ['x', 'X'].includes(prescriptionAPI.O2ConcentratorFix ?? ''),
      ['x', 'X'].includes(prescriptionAPI.O2ConcentratorAmbulation ?? ''),
      prescriptionAPI.O2ConcentratorDuration,
      prescriptionAPI.O2ConcentratorFlow,
      prescriptionAPI.O2GaseousBottle == 1,
      ['x', 'X'].includes(prescriptionAPI.O2GaseousBottleFix ?? ''),
      ['x', 'X'].includes(prescriptionAPI.O2GaseousBottleAmbulation ?? ''),
      prescriptionAPI.O2GaseousBottleDuration,
      prescriptionAPI.O2GaseousBottleFlow,
      prescriptionAPI.O2Liquid == 1,
      ['x', 'X'].includes(prescriptionAPI.O2LiquidFix ?? ''),
      ['x', 'X'].includes(prescriptionAPI.O2LiquidAmbulation ?? ''),
      prescriptionAPI.O2LiquidDuration,
      prescriptionAPI.O2LiquidFlow,
      prescriptionAPI.O2VentilMouthPiece == 1,
      prescriptionAPI.O2VentilMouthPieceDuration,
      prescriptionAPI.O2VentilMouthPieceFlow,
      prescriptionAPI.O2VentilNasalMask == 1,
      prescriptionAPI.O2VentilNasalMaskDuration,
      prescriptionAPI.O2VentilNasalMaskFlow,
      prescriptionAPI.O2VentilTracheotomy == 1,
      prescriptionAPI.O2VentilTracheotomyDuration,
      prescriptionAPI.O2VentilTracheotomyFlow,
      prescriptionAPI.O2VentilExtrathoracicProsthesis == 1,
      prescriptionAPI.O2VentilExtrathoracicProsthesisDuration,
      prescriptionAPI.O2VentilExtrathoracicProsthesisFlow,
      prescriptionAPI.O2VentilContinuousPositivePressure == 1,
      prescriptionAPI.O2VentilCPPDuration,
      prescriptionAPI.O2VentilCPPFlow,
      prescriptionAPI.O2Suction == 1,
      prescriptionAPI.O2OthersTreatment == 1,
      prescriptionAPI.O2ConcentratorBrand,
      prescriptionAPI.O2ConcentratorType,
      prescriptionAPI.O2VentilatorBrand,
      prescriptionAPI.O2VentilatorType,
      prescriptionAPI.O2LiquidBrand,
      prescriptionAPI.O2LiquidType,
      prescriptionAPI.O2OtherBrand,
      prescriptionAPI.O2OtherType,
    );
  }

  public alerteDateDebut(): boolean {
    return this.dateDebut.getTime() < new Date().getTime();
  }

  public alerteDateFin(): boolean {
    return this.dateFin.getTime() < new Date().getTime();
  }
}

export type PrescriptionAPI = {
  Number: number;
  StartApplicationDate: string;
  EndApplicationDate: string;
  PrescriberResponseDate: string;
  prescription_form?: PrescriptionFormAPI;
  DemandNature: number;
  DemandKind: number;
  read_only?: boolean;
  PersonalAccident?: number;
  PersonalAccidentDate?: string;
  O2WarPensioner?: number;
  HealthCoverage?: number;
  ALDonList?: number;
  ALDoutsideList?: number;
  O2Stamp?: number;
  O2Organization?: number;
  O2OrganizationName?: string;
  O2OrganizationAddress1?: string;
  O2OrganizationAddress2?: string;
  CarePackageNumber?: string;
  O2OtherPrescriberLabel?: string;
  O2Concentrator?: number;
  O2ConcentratorFix?: string;
  O2ConcentratorAmbulation?: string;
  O2ConcentratorDuration?: string;
  O2ConcentratorFlow?: string;
  O2GaseousBottle?: number;
  O2GaseousBottleFix?: string;
  O2GaseousBottleAmbulation?: string;
  O2GaseousBottleDuration?: string;
  O2GaseousBottleFlow?: string;
  O2Liquid?: number;
  O2LiquidFix?: string;
  O2LiquidAmbulation?: string;
  O2LiquidDuration?: string;
  O2LiquidFlow?: string;
  O2VentilMouthPiece?: number;
  O2VentilMouthPieceDuration?: string;
  O2VentilMouthPieceFlow?: string;
  O2VentilNasalMask?: number;
  O2VentilNasalMaskDuration?: string;
  O2VentilNasalMaskFlow?: string;
  O2VentilTracheotomy?: number;
  O2VentilTracheotomyDuration?: string;
  O2VentilTracheotomyFlow?: string;
  O2VentilExtrathoracicProsthesis?: number;
  O2VentilExtrathoracicProsthesisDuration?: string;
  O2VentilExtrathoracicProsthesisFlow?: string;
  O2VentilContinuousPositivePressure?: number;
  O2VentilCPPDuration?: string;
  O2VentilCPPFlow?: string;
  O2Suction?: number;
  O2OthersTreatment?: number;
  O2ConcentratorBrand?: string;
  O2ConcentratorType?: string;
  O2VentilatorBrand?: string;
  O2VentilatorType?: string;
  O2LiquidBrand?: string;
  O2LiquidType?: string;
  O2OtherBrand?: string;
  O2OtherType?: string;
};
export class PrescriptionList {
  data: Prescription[];
  total: number;
  currentPage?: number;
  lastPage?: number;
  perPage?: number;
  from?: number;
  to?: number;

  constructor(
    data: Prescription[],
    total: number,
    currentPage?: number,
    lastPage?: number,
    perPage?: number,
    from?: number,
    to?: number,
  ) {
    this.data = data;
    this.total = total;
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.perPage = perPage;
    this.from = from;
    this.to = to;
  }

  static factory(prescriptionListAPI: PrescriptionListAPI): PrescriptionList {
    return new PrescriptionList(
      prescriptionListAPI.data.map((prescription: PrescriptionAPI) =>
        Prescription.factory(prescription),
      ),
      prescriptionListAPI.total,
      prescriptionListAPI.current_page,
      prescriptionListAPI.last_page,
      prescriptionListAPI.per_page,
      prescriptionListAPI.from,
      prescriptionListAPI.to,
    );
  }
}

export type PrescriptionListAPI = {
  data: PrescriptionAPI[];
  total: number;
  current_page?: number;
  last_page?: number;
  per_page?: number;
  from?: number;
  to?: number;
};
